export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex max-w-sm flex-col items-center gap-3 text-center text-white">
      <span className="text-4xl">😕</span>
      <p className="text-lg font-semibold">Oops! {message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="rounded-full bg-amber-400 px-6 py-2 font-bold text-slate-900"
        >
          Try again
        </button>
      )}
    </div>
  );
}
